import { Calendar, Globe, MapPin, Users } from "lucide-react";
import React from "react";
import AchievementReusableComponent from "../../utilitis/AchievementReusable";

const CulturalDisplay = () => {
  const achievementData = {
    title: "Cultural Display",
    subtitle: "Celebrating Diversity Through Art and Tradition",
    description:
      "Vibrant exhibitions highlighting diverse artistic expressions and heritage.",
    images: [
      "https://i.ibb.co/TcYSzC4/ghana-sis.jpg",
      "https://i.ibb.co/kGCQ05w/Hcommisoner-lights.jpg",
      "https://i.ibb.co/c2jhTZk/vizag-family.jpg",
      "https://i.ibb.co/gZ4BXQf/swareh.jpg",
    ],
    iconTexts: [
      { icon: Calendar, text: "Bi-Annual Event" },
      { icon: MapPin, text: "Cultural Center" },
      { icon: Users, text: "50+ Participated" },
      { icon: Globe, text: "8+ Cultures Represented" },
    ],
    highlights: [
      "Art exhibitions featuring traditional and contemporary works",
      "Live performances of music and dance from various cultures",
      "Traditional craft demonstrations and workshops",
      "Cultural fashion show showcasing traditional attire",
      "International food festival with cuisine from different regions",
    ],
    upcomingEvents: [
      {
        title: "Opening Night Gala",
        description: "Featuring performances from all participating cultures",
        date: "December 1, 2024",
      },
      {
        title: "Art Walk",
        description: "Guided tour of the cultural art exhibitions",
        date: "December 3, 2024",
      },
      {
        title: "World Music Concert",
        description: "A fusion of traditional and modern global music",
        date: "December 5, 2024",
      },
    ],
    galleryLink: "/gallery",
  };

  return <AchievementReusableComponent {...achievementData} />;
};

export default CulturalDisplay;
